import { NotificationCard } from '../../components/Card';
import { Flex, Icon, Center, Button } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { LayersThree01 } from '@kula-ai/icons/dual-tone/LayersThree01';
import { NotificationTime } from '../../components/Time';
import {
  RequisitionDetailsSection,
  RequisitionDetailsList,
  RequisitionCustomFieldsSection,
  useRequisitionData,
} from './components';
import { KText } from '@/ui-library/components';

const RequisitionApproved = ({
  notification = {},
  onClose = () => {},
}: {
  notification?: any;
  onClose?: () => void;
}) => {
  const {
    requisition_id,
    requisition_code,
    requisition_ids,
    requisition_codes,
    role_name,
    buildRequisitionDetails,
    custom_fields,
    requester_name,
    submitted_by_name,
    data,
  } = useRequisitionData(notification);

  const { is_final } = data || {};
  const history = useHistory();

  const displayCode = requisition_codes
    ? Array.isArray(requisition_codes)
      ? requisition_codes.join(', ')
      : requisition_codes
    : requisition_code;

  const isBulk = requisition_ids && requisition_ids.length > 0;

  const detailsData = buildRequisitionDetails([
    { label: 'Requested by', value: requester_name || 'User' },
  ]);

  const handleViewRequisition = () => {
    if (requisition_id || requisition_ids?.[0]) {
      history.push(
        `/requisitions?view=${requisition_id || requisition_ids?.[0]}`
      );
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="pastel-2-light">
        <Icon as={LayersThree01} color="pastel-2-dark" width="16px" />
      </Center>
      <Flex
        flexDir="column"
        ml="16px"
        gap="8px"
        alignSelf="start"
        flex="1"
        minW="0"
      >
        <KText>
          {is_final ? (
            // Final approval - requisition is approved and ready for hiring
            <>
              {isBulk ? 'Requisitions' : 'Requisition'}{' '}
              <KText as="span" fontWeight="semiBold">
                {displayCode}
              </KText>{' '}
              for{' '}
              <KText as="span" fontWeight="semiBold">
                {role_name}
              </KText>{' '}
              {isBulk ? 'are' : 'is'} approved and ready for hiring
            </>
          ) : isBulk ? (
            // Bulk partial approval - no user mentioned
            <>
              Requisitions{' '}
              <KText as="span" fontWeight="semiBold">
                {displayCode}
              </KText>{' '}
              for{' '}
              <KText as="span" fontWeight="semiBold">
                {role_name}
              </KText>{' '}
              are approved
            </>
          ) : (
            // Single partial approval - user mentioned
            <>
              <KText as="span" fontWeight="semiBold">
                {submitted_by_name || 'User'}
              </KText>{' '}
              has approved requisition{' '}
              <KText as="span" fontWeight="semiBold">
                {displayCode}
              </KText>{' '}
              for{' '}
              <KText as="span" fontWeight="semiBold">
                {role_name}
              </KText>
            </>
          )}
        </KText>

        <KText size="sm-medium" color="secondary-700">
          Approved by:
          <KText as="span" fontWeight="regular" ml="4px">
            {submitted_by_name || 'User'}
          </KText>
        </KText>

        <RequisitionDetailsSection>
          <RequisitionDetailsList data={detailsData} />
          <RequisitionCustomFieldsSection customFields={custom_fields} />
        </RequisitionDetailsSection>

        <Button
          variant="primary"
          onClick={handleViewRequisition}
          size="sm"
          w="fit-content"
        >
          View requisition
        </Button>

        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const RequisitionApprovedNotification = ({
  notification = {},
  onClose = () => {},
}: {
  notification?: any;
  onClose?: () => void;
}) => {
  return (
    <NotificationCard notification={notification}>
      <RequisitionApproved notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
